import React from 'react'
import { useLocation } from 'react-router-dom'
import config from '../Config'
import { t } from '../i18n'
import { track } from '../Utils/analytics'
import { LogoIcon } from './Logo'

const UTM = 'utm_source=web&utm_medium=open_bar'
const isAndroid = /android/i.test(navigator.userAgent || '')

/* "Otvori" opens the screen being read (story, topic, source…) in the app when
   it's installed, and the store when it's not.
   - Android: an intent:// link with the app's own scheme; Chrome opens the
     app on that screen, or Google Play (browser_fallback_url).
   - iOS and the rest: the smart link on www. A Universal Link only opens the
     app when tapped on a page of another host, so instapres.com links from
     instapres.com always stayed in the browser. The app handles
     /app?to=… (opens `to`); without it, www redirects to instapres.com/app,
     which sends the reader to the App Store (spec 8). */
export function openInAppHref(to) {
  if (isAndroid) {
    const store = `${config.PLAY_STORE_LINK}&referrer=${encodeURIComponent(UTM)}`
    return (
      `intent://${to.replace(/^\/+/, '')}#Intent;scheme=${config.APP_SCHEME};` +
      `package=${config.ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(store)};end`
    )
  }
  return `${config.OPEN_IN_APP_LINK}?to=${encodeURIComponent(to)}&${UTM}`
}

/* Mobile web: always-visible "Otvori u aplikaciji" bar (spec 7.1). */
export default function AppBar() {
  const location = useLocation()
  const to = `${location.pathname}${location.search}`
  return (
    <div className="app-bar">
      <LogoIcon size={38} className="app-bar-icon" />
      <div className="app-bar-text">
        <strong>{t('appBar.title')}</strong>
        <span>{t('appBar.text')}</span>
      </div>
      <a
        className="btn btn-primary btn-small"
        href={openInAppHref(to)}
        onClick={() => track('open_in_app_click', { to })}
      >
        {t('appBar.open')}
      </a>
    </div>
  )
}
